import { Link } from "react-router";
import { AlertCircle, ExternalLink } from "lucide-react";
import { formatCount } from "@shared-core/domain/formatters";
import { Card } from "../../primitives/card";
import { paths } from "@shared-core/routing/routes";

interface AlertsMetricCardProps {
  criticalCount: number;
  highCount: number;
}

export function AlertsMetricCard({
  criticalCount,
  highCount,
}: AlertsMetricCardProps) {
  const total = criticalCount + highCount;
  const hasCritical = criticalCount > 0;

  return (
    <Link to={paths.alerts()}>
      <Card className="p-4 hover:bg-muted/50 transition-colors cursor-pointer">
        <div className="flex items-start justify-between mb-2">
          <div className="flex-1">
            <div className="text-sm text-muted-foreground mb-1 flex items-center gap-2">
              <AlertCircle className="size-4" />
              Alerts
            </div>
            <div className="text-3xl font-bold text-foreground">
              {formatCount(total)}
            </div>
            <div className="text-sm text-muted-foreground mt-1">
              {total === 0
                ? "No active alerts"
                : `${formatCount(criticalCount)} critical • ${formatCount(highCount)} high`}
            </div>
          </div>
          <div
            className={`
            p-2 rounded-full
            ${
              hasCritical
                ? "bg-red-500/10"
                : total > 0
                  ? "bg-amber-500/10"
                  : "bg-green-500/10"
            }
          `}
          >
            <AlertCircle
              className={`
              size-5
              ${
                hasCritical
                  ? "text-red-600"
                  : total > 0
                    ? "text-amber-600"
                    : "text-green-600"
              }
            `}
            />
          </div>
        </div>

        <div className="text-xs text-primary inline-flex items-center gap-1">
          View all my alerts
          <ExternalLink className="size-3" />
        </div>
      </Card>
    </Link>
  );
}
